import { useRoutes } from "react-router-dom";
import { Provider } from "react-redux";
import router from "src/router";
import store from "src/store";
import "normalize.css";
import packageJson from "src/../package.json";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    console.log("version", packageJson.version);

    if (process.env.NODE_ENV === "production") {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = `
        var _hmt = _hmt || [];
        (function() {
          var hm = document.createElement("script");
          hm.src = "https://hm.baidu.com/hm.js?2498d3a69b22bd8b4fc01c1729b83d3e";
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(hm, s);
        })();
      `;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <Provider store={store}>
      <div className="App">{useRoutes(router)}</div>
    </Provider>
  );
}

export default App;
